import { useWorkspaces } from '@/hooks/useWorkspaces';

export function useWorkspaceCustomImage(workspaceId: string | null | undefined): string | null {
  const { data: workspaces } = useWorkspaces();
  if (!workspaceId) return null;
  const image = workspaces?.find((w) => w.id === workspaceId)?.image;
  return image && image.startsWith('data:image/') ? image : null;
}
